import MetricCard from "./MetricCard";
import NotificationCard from "./NotificationCard";
import { Bell, Select, Button } from "../../ui";
import { getLocalized } from "../utils/notificationHelpers";
import { useContext } from "react";
import { Context } from "../../../context/Context";
import { useAccess } from "../../../access/hooks/useAccess";
import { Loading } from "../../loading/Loading";

const FILTER_KEYS = ["all", "menu", "manager", "report", "ticket", "billing", "operations"];

export default function NotificationsInbox({
  restaurants,
  notifications,
  stats,
  filters,
  setFilters,
  t,
  loading = false,
  error = null,
  pendingIds,
  onMarkRead,
  onOpen,
}) {
  const { lang = "ar" } = useContext(Context);
  const { can } = useAccess();
  const selectedOwner = restaurants.find(
    (owner) => owner.id === filters.ownerId,
  );

  return (
    <div className="lud-notif-view">
      <div className="lud-notif-metrics-row">
        <MetricCard
          icon={Bell}
          value={stats.all}
          label={t.metrics.total}
          variant="primary"
        />
        <MetricCard
          icon={Bell}
          value={stats.unread}
          label={t.metrics.unread}
          variant="warning"
        />
        <MetricCard
          icon={Bell}
          value={stats.read}
          label={t.metrics.read}
          variant="success"
        />
      </div>
      <div className="lud-notif-filter-bar">
        {can("notification.inbox.filters") && (
          <div className="lud-notif-filter-chips">
            {FILTER_KEYS.map((key) => (
              <Button
                key={key}
                type="button"
                variant={filters.category === key ? "primary" : "neutral"}
                appearance={filters.category === key ? "filled" : "soft"}
                aria-pressed={filters.category === key}
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    category: key,
                  }))
                }
              >
                {t.filters[key]}
              </Button>
            ))}
          </div>
        )}

        <div className="lud-notif-filter-selects">
          <Select
            fullWidth={false}
            value={filters.ownerId}
            onChange={(event) =>
              setFilters((prev) => ({
                ...prev,
                ownerId: event.target.value,
                branchId: "",
              }))
            }
            options={[
              { value: "", label: t.filters.allRestaurants },
              ...restaurants.map((owner) => ({
                value: owner.id,
                label: getLocalized(owner, "name", "nameEn", lang),
              })),
            ]}
          />

          <Select
            fullWidth={false}
            value={filters.branchId}
            disabled={!selectedOwner}
            onChange={(event) =>
              setFilters((prev) => ({
                ...prev,
                branchId: event.target.value,
              }))
            }
            options={[
              {
                value: "",
                label: selectedOwner
                  ? `${t.filters.allBranches} ${getLocalized(
                      selectedOwner,
                      "name",
                      "nameEn",
                      lang,
                    )}`
                  : t.filters.allBranches,
              },
              ...(selectedOwner?.branches || []).map((branch) => ({
                value: branch.id,
                label: getLocalized(branch, "name", "nameEn", lang),
              })),
            ]}
          />

          <Select
            fullWidth={false}
            value={filters.status}
            onChange={(event) =>
              setFilters((prev) => ({
                ...prev,
                status: event.target.value,
              }))
            }
            options={[
              { value: "all", label: t.filters.allStatuses },
              { value: "unread", label: t.filters.unread },
              { value: "read", label: t.filters.read },
            ]}
          />
        </div>
      </div>

      <div className="lud-notif-list" aria-busy={loading || undefined}>
        {error ? (
          error
        ) : loading && !notifications.length ? (
          <Loading inline />
        ) : notifications.length ? (
          notifications.map((notification) => (
            <NotificationCard
              key={notification.id}
              notification={notification}
              restaurants={restaurants}
              lang={lang}
              t={t}
              pending={pendingIds?.has(notification.id)}
              onMarkRead={onMarkRead}
              onOpen={onOpen}
            />
          ))
        ) : (
          <div className="lud-notif-empty">
            <Bell size={38} />
            <span>{t.filters.noNotifications}</span>
          </div>
        )}
      </div>
    </div>
  );
}
